import AssistantChat from "../components/AssistantChat";

export default function Coach() {
  return (
    <div data-testid="coach-page" className="px-4 md:px-8 pb-6 pt-2 flex flex-col h-[calc(100vh-3.5rem)] md:h-[calc(100vh-5rem)]">
      <AssistantChat variant="page" />
    </div>
  );
}
